import { ColDef, SideBarDef } from "ag-grid-community";
import {
  ReactElement,
  JSXElementConstructor,
  ReactNode,
  ReactPortal,
  useMemo,
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export const DEFAULT_COL_DEF: ColDef = {
  // sortable: true,
  //sort: 'asc',
  filter: "agSetColumnFilter",
  resizable: true,
  menuTabs: ["filterMenuTab"],
  suppressHeaderContextMenu: true,
};

export const FILTER_SIDEBAR: SideBarDef = {
  toolPanels: [
    {
      id: "filters",
      labelDefault: "",
      labelKey: "filters",
      iconKey: "filter",
      toolPanel: "agFiltersToolPanel",
      minWidth: 180,
      maxWidth: 400,
      width: 250,
    },
  ],
  position: "left",
  defaultToolPanel: "filters",
};

export const FLEET_DEFAULT_COL_DEF: ColDef = {
  sortable: true,
  sort: "asc",
  filter: "agSetColumnFilter",
  resizable: true,
  menuTabs: ["filterMenuTab"],
  suppressHeaderContextMenu: true,
};

const DATA_UNAVAILABLE = "Data Unavailable";
const GRID_NO_RESULTS = "No Results Found";

export const smallGrid: { height: string } = { height: "300px" };
export const bigGrid: { height: string } = { height: "470px" };
export const loadingTemplate: string = `<span class="ag-overlay-loading-center">Loading...</span>`;
export const noRowsTemplate: string = `<span class="ag-overlay-loading-center">${DATA_UNAVAILABLE}</div>`;
export const noFilteredRowsTemplate: string = `<span class="ag-overlay-loading-center">${GRID_NO_RESULTS}</span>`;

export const DEFAULT_GRID_OPTIONS = {
  overlayLoadingTemplate: loadingTemplate,
  noRowsOverlayComponent: noRowsTemplate,
  overlayNoFilteredRowsTemplate: noFilteredRowsTemplate,
};

export const CustomNoRowsOverlay: any = (props: {
  noRowsMessageFunc: () =>
    | string
    | number
    | bigint
    | boolean
    | ReactElement<unknown, string | JSXElementConstructor<any>>
    | Iterable<ReactNode>
    | ReactPortal
    | Promise<
        | string
        | number
        | bigint
        | boolean
        | ReactPortal
        | ReactElement<unknown, string | JSXElementConstructor<any>>
        | Iterable<ReactNode>
        | null
        | undefined
      >
    | null
    | undefined;
}) => {
  return (
    <div role="presentation" className="ag-overlay-loading-center">
      <FontAwesomeIcon icon={faTriangleExclamation} size="2x" />
      {props.noRowsMessageFunc()}
    </div>
  );
};

export const noRowsOverlayComponentParams = () => {
  return {
    noRowsMessageFunc: () => "No records found",
  };
};
